import React, { useEffect, useState } from 'react';

import styles from './addJobOne.module.scss';
import jobService, { job$ } from '../../utils/services/jobService';
import { techStack } from '../../utils/data/techStack';

const AddJobOne = ({
  jobPost,
  setJobPost,
  steps,
  setSteps,
  onChangeHandle,
  setCreatedPostId,
}) => {
  //Search mechanic states
  const [searchField, setSearchField] = useState('');
  const [stack, setStack] = useState(techStack);
  const [filteredStack, setFilteredStack] = useState(stack);

  //state for selected tech
  const [selectedTech, setSelectedTech] = useState([]);

  useEffect(() => {
    const filteredStack = stack.filter((tech) => {
      return tech.name.toLowerCase().includes(searchField);
    });
    setFilteredStack(filteredStack);
  }, [stack, searchField]);

  useEffect(() => {
    setJobPost({ ...jobPost, tech: selectedTech });
  }, [selectedTech]);

  const onSearchChange = (e) => {
    const searchFieldString = e.target.value.toLowerCase();
    setSearchField(searchFieldString);
  };

  const techOnClickHandle = (e) => {
    const selected = e.target.getAttribute('data-value');

    if (selectedTech.includes(selected)) {
      return;
    } else {
      setSelectedTech([...selectedTech, selected]);
    }
  };

  const selectedOnClickHandle = (e) => {
    const remove = e.target.getAttribute('data-value');
    const clearedItems = selectedTech.filter((selected) => selected !== remove);
    setSelectedTech(clearedItems);
    setJobPost({ ...jobPost, tech: clearedItems });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSteps({ ...steps, stepTwo: true });

    const formData = {
      title: jobPost.jobTitle,
      description: jobPost.description,
      tech: jobPost.tech,
    };
    console.log(formData);

    const result = jobService.createJob(formData).then((res) => {
      console.log(res);
      if (res.data?.success) {
        setCreatedPostId(res.data.data._id);
      }
    });
  };

  return (
    <section className={styles.jobInfo}>
      <form className={styles.jobInfoForm} action="">
        <div className={styles.formGroup}>
          <input
            type="text"
            name="jobTitle"
            tabIndex="1"
            aria-label="Enter job title"
            placeholder="Job title *"
            onChange={(e) => {
              onChangeHandle(e);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <textarea
            name="description"
            tabIndex="2"
            aria-label="Enter job description"
            placeholder="Job description *"
            cols="30"
            rows="10"
            onChange={(e) => {
              onChangeHandle(e);
            }}
          ></textarea>
        </div>
        <div className={styles.formGroup}>
          <input
            type="search"
            tabIndex="3"
            aria-label="Search tech and choose from list below"
            placeholder="Search and choose your tech"
            onChange={(e) => {
              onSearchChange(e);
            }}
          />
        </div>
      </form>
      <div className={styles.displayStack}>
        <p>Click on the items to select tech</p>
        <div className={styles.itemsWrapper}>
          {filteredStack.map((tech, index) => (
            <span
              key={index}
              tabIndex={index + 3}
              data-value={tech.name}
              className={`${styles.itemsWrapper_item}`}
              onClick={(e) => {
                techOnClickHandle(e);
              }}
            >
              {tech.name}
            </span>
          ))}
        </div>
      </div>
      <div className={styles.techSelectedWrapper}>
        <p>You've chosen</p>
        <div className={styles.techSelected}>
          {selectedTech.map((selected, index) => (
            <span
              key={index}
              data-value={selected}
              className={styles.techSelected_item}
              onClick={(e) => {
                selectedOnClickHandle(e);
              }}
            >
              {selected}
            </span>
          ))}
        </div>
      </div>
      {jobPost.jobTitle !== '' &&
      jobPost.description !== '' &&
      jobPost.tech.length > 0 ? (
        <button
          className={styles.btnActive}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Continue
        </button>
      ) : (
        <button type="button" className={styles.btn}>
          Continue
        </button>
      )}
    </section>
  );
};

export default AddJobOne;
